<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">ALL RAISED BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Raised Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">All Raised Bills</h4>
                      <div class="d-flex gap-2">

                        <!-- Duplicate Selected Button -->
<!--                        <button v-if="selectedBills.length > 0 && sessionStatusCode === '2'"
                                class="btn btn-warning text-white"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#duplicateBillsModal">
                          <i class="mdi mdi-content-copy font-size-16"></i>
                          <span class="d-md-inline ms-1">Duplicate Selected ({{ selectedBills.length }})</span>
                        </button>-->

                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Revenue Stream Filter -->
                      <div class="col-md-3">
                        <label class="form-label mb-1">Revenue Stream:</label>
                        <select @change="filterByStream($event)" class="form-select">
                          <option value="">All Streams</option>
                          <option v-for="stream in streams" :key="stream.id" :value="stream.incomeTypePrefix">
                            {{ stream.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-9">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search... eg Business Name, ID Number, Bill Number, etc">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location and Date Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-end">
                      <!-- Location Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select class="form-select" v-model="subCounty" @change="getBillsPaginate()">
                          <option value="">All Sub Counties</option>
                          <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select class="form-select" v-model="ward" @change="getZones(ward.wardID, ward.wardName)">
                          <option value="">All Wards</option>
                          <option v-for="item in wards" :key="item.wardID" :value="item">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Zone:</label>
                        <select class="form-select" v-model="zone" @change="getUsers(zone)">
                          <option value="">All Zones</option>
                          <option v-for="item in zones" :key="item.zone" :value="item.zone">
                            {{ item.zone }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Attendant:</label>
                        <select class="form-select" v-model="selectedUser" @change="getBillsPaginate()">
                          <option value="">All Attendants</option>
                          <option v-for="item in users" :key="item.idNo" :value="item.idNo">
                            {{ item.names }}
                          </option>
                        </select>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">From:</label>
                        <input v-model="dateFrom" class="form-control" type="date">
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">To:</label>
                        <input v-model="dateTo" class="form-control" type="date">
                      </div>
                    </div>

                    <!-- Download Buttons -->
                    <div class="mt-3">
                      <div class="btn-group" role="group">
                        <!-- Download Current Page -->
                        <button
                            v-if="getRight('DOWNLOAD UNPAID INVOICES')"
                            @click="downloadCurrentPage()"
                            type="button"
                            class="btn btn-success"
                            :disabled="billDetails.length === 0">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="ms-1">Download Current Page ({{ billDetails.length }} records)</span>
                        </button>

                        <!-- Download All Records -->
                        <button
                            v-if="getRight('DOWNLOAD UNPAID INVOICES')"
                            @click="downloadAllRecords()"
                            type="button"
                            class="btn btn-primary"
                            :disabled="isDownloadingAll || summary.count === 0">
                          <span v-if="isDownloadingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Downloading...
                          </span>
                          <span v-else>
                            <i class="bx bxs-cloud-download font-size-16"></i>
                            <span class="ms-1">Download All ({{ numberFormat(summary.count) }} records)</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Summary Stats Bar -->
                  <div class="card-header bg-light border-bottom py-2">
                    <div class="row text-center">
                      <div class="col-md-4">
                        <div class="d-flex align-items-center justify-content-center">
                          <i class="bx bx-file text-primary fs-4 me-2"></i>
                          <div class="text-start">
                            <small class="text-muted d-block">Total Invoices</small>
                            <strong class="fs-5 text-primary">{{ numberFormat(summary.count) }}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="d-flex align-items-center justify-content-center">
                          <i class="bx bx-show text-secondary fs-4 me-2"></i>
                          <div class="text-start">
                            <small class="text-muted d-block">Showing</small>
                            <strong class="fs-5">{{ billDetails.length }} of {{ numberFormat(summary.count) }}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="d-flex align-items-center justify-content-center">
                          <i class="bx bx-filter text-success fs-4 me-2"></i>
                          <div class="text-start">
                            <small class="text-muted d-block">Pages</small>
                            <strong class="fs-5">{{ currentPage }} / {{ totalPages }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th v-if="sessionStatusCode === '2'" class="text-nowrap">
                            <input type="checkbox" class="form-check-input"
                                   @change="toggleSelectAll($event)"
                                   :checked="selectedBills.length === billDetails.length && billDetails.length > 0">
                          </th>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap" style="min-width: 200px;">Description</th>
                          <th class="text-nowrap">Location</th>
                          <th class="text-nowrap">Attendant</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap">Receipted By</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billDetails" :key="index"
                            :class="{'table-primary': isBillSelected(item.billNo)}">
                          <td v-if="sessionStatusCode === '2'" class="text-nowrap">
                            <input type="checkbox" class="form-check-input"
                                   :checked="isBillSelected(item.billNo)"
                                   @change="toggleBillSelection(item)">
                          </td>
                          <td class="text-nowrap">
                            <a href="javascript:void(0)"
                               class="text-decoration-none">
                              {{ index + 1 }}
                            </a>
                          </td>
                          <td class="text-nowrap">
                            <a href="javascript:void(0)" @click="dismissBill(item.billNo)"
                               class="text-decoration-none fw-semibold">
                              {{ item.billNo }}
                            </a>
                          </td>
                          <td style="min-width: 200px;">
                            <div>
                              <strong>{{ item.description }}</strong>
                              <small class="text-muted d-block">({{ item.incomeTypeDescription }})</small>
                              <small class="text-muted d-block">{{ item.feeDescription }}</small>
                              <small class="text-muted d-block">{{ maskPhoneNumber(item.customers) }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <div>{{ item.subCountyName }}</div>
                              <small class="text-muted">{{ item.wardName }}</small>
                              <small class="text-muted d-block">{{ item.zone }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.names }}</td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.detailAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.receiptAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.billBalance) }}</span>
                          </td>
                          <td>
                                <span v-if="item.status === 'PAID'"
                                      class="badge bg-success text-uppercase"
                                      @click="invalidatePayment(item.billNo)"
                                      style="cursor: pointer;">
                                  {{ item.status }}
                                </span>
                            <span v-else class="badge bg-danger text-uppercase">
                                  UNPAID
                                </span>
                          </td>
                          <td class="text-nowrap">{{ item.dateCreated }}</td>
                          <td class="text-nowrap">{{ item.receiptedBy }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="getBill(item.billNo)"
                                      class="btn btn-primary btn-sm me-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#billDetailModal">
                                View
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li><a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-printer me-2"></i>Print</a></li>
                                  <li><a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-email me-2"></i>Email Reminder</a></li>
                                  <li><a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-chat me-2"></i>SMS Reminder</a></li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th v-if="sessionStatusCode === '2'"></th>
                          <th colspan="5" class="text-end">{{ billDetails.length }} Bills</th>
                          <th class="text-end">{{ totalDetailAmount }}</th>
                          <th class="text-end">{{ totalReceiptAmount }}</th>
                          <th class="text-end">{{ totalBillBalance }}</th>
                          <th colspan="4"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Data</h4>
                        <p>We are fetching the data for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="billDetails.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Results To Show</h4>
                        <p>Sorry, we could not find any results that match your search or filter criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="150">150 Rows</option>
                          <option value="200">200 Rows</option>
                          <option value="5000">5000 Rows</option>
                          <option value="10000">10000 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ==================== DUPLICATE BILLS MODAL ==================== -->
        <div class="modal fade" id="duplicateBillsModal" tabindex="-1">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-warning text-white">
                <h5 class="modal-title text-white">
                  <i class="mdi mdi-content-copy me-2"></i>Duplicate Bills
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">

                <!-- Selected Bills Summary -->
                <div class="mb-3">
                  <h6 class="fw-bold">Selected Bills ({{ selectedBills.length }}):</h6>
                  <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
                    <table class="table table-sm table-bordered mb-0">
                      <thead class="table-light">
                      <tr>
                        <th>Bill No</th>
                        <th>Description</th>
                        <th>Income Type</th>
                        <th class="text-end">Amount</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="bill in selectedBills" :key="bill.billNo">
                        <td class="fw-semibold">{{ bill.billNo }}</td>
                        <td>{{ bill.description }}</td>
                        <td><span class="badge bg-info">{{ bill.incomeTypePrefix }}</span></td>
                        <td class="text-end">{{ formatPrice(bill.detailAmount) }}</td>
                        <td>
                          <button class="btn btn-outline-danger btn-sm" @click="removeBillFromSelection(bill.billNo)">
                            <i class="mdi mdi-close"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <hr>

                <!-- Duplication Settings -->
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Target Sub County <span class="text-danger">*</span></label>
                    <select class="form-select" v-model="dupTargetSubCounty">
                      <option value="">Select Sub County</option>
                      <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                        {{ item.subCountyName }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label fw-bold">Number of Copies <span class="text-danger">*</span></label>
                    <input type="number" class="form-control" v-model.number="dupCopies" min="1" max="5000" placeholder="e.g. 176">
                  </div>

                  <div class="col-md-6">
                    <label class="form-label fw-bold">Date From <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" v-model="dupDateFrom">
                  </div>

                  <div class="col-md-6">
                    <label class="form-label fw-bold">Date To <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" v-model="dupDateTo">
                  </div>

                  <div class="col-md-6">
                    <label class="form-label fw-bold">Bill Status</label>
                    <select class="form-select" v-model="dupBillStatus">
                      <option value="UNPAID">UNPAID</option>
                      <option value="PAID">PAID</option>
                    </select>
                  </div>
                </div>

                <!-- Summary -->
                <div class="alert alert-info mt-3 mb-0">
                  <i class="bx bx-info-circle me-2"></i>
                  <strong>{{ dupCopies }}</strong> new <strong>{{ dupBillStatus }}</strong> bills will be created in
                  <strong>{{ dupTargetSubCounty?.subCountyName || '(select sub county)' }}</strong>,
                  randomly picking from <strong>{{ selectedBills.length }}</strong> selected bill(s).
                  Dates spread between <strong>{{ dupDateFrom || '(select)' }}</strong> and <strong>{{ dupDateTo || '(select)' }}</strong>.
                  Only bill number and date change — all other details stay exactly the same.
                </div>

                <!-- Duplication Result -->
                <div v-if="dupResult" class="mt-3">
                  <div :class="dupResult.success ? 'alert alert-success' : 'alert alert-danger'">
                    <i :class="dupResult.success ? 'mdi mdi-check-circle' : 'mdi mdi-alert-circle'" class="me-2"></i>
                    {{ dupResult.message }}
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                  <i class="mdi mdi-close me-1"></i>Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-warning text-white"
                    @click="submitDuplicateBills"
                    :disabled="!canDuplicate || dupGenerating">
                  <span v-if="dupGenerating">
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    Generating {{ dupCopies }} bills...
                  </span>
                  <span v-else>
                    <i class="mdi mdi-content-copy me-1"></i>Generate {{ dupCopies }} Bills
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
        <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title text-white">
                  <i class="bx bxs-download me-2"></i>Downloading All Records
                </h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-3">
                  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="mb-3">
                    <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                  </div>
                  <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                  <h5 v-else class="text-warning">Download Paused</h5>

                  <!-- Estimated Time Remaining -->
                  <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                    <p class="text-muted mb-1">
                      <i class="bx bx-time-five me-1"></i>
                      <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                    </p>
                    <small class="text-muted">
                      Average speed: {{ downloadProgress.averageSpeed }} records/sec
                    </small>
                  </div>

                  <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
                </div>

                <div class="progress mb-3" style="height: 25px;">
                  <div
                      class="progress-bar progress-bar-striped"
                      :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                      role="progressbar"
                      :style="{ width: downloadProgress.percentage + '%' }"
                      :aria-valuenow="downloadProgress.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100">
                    {{ downloadProgress.percentage }}%
                  </div>
                </div>

                <div class="d-flex justify-content-between text-muted small mb-3">
                  <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                  <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
                </div>

                <!-- Error Display -->
                <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                  <i class="bx bx-error-circle me-2"></i>
                  <div class="flex-grow-1">
                    <strong>Error:</strong> {{ downloadError }}
                    <br>
                    <small>You can retry from where it stopped or cancel the download.</small>
                  </div>
                </div>

                <!-- Retry Count Display -->
                <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>Retry attempt {{ downloadRetryCount }} of 3</small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <button
                      v-if="!downloadPaused && !downloadError"
                      @click="pauseDownload"
                      class="btn btn-warning btn-sm">
                    <i class="bx bx-pause me-1"></i>Pause
                  </button>
                  <button
                      v-if="downloadPaused || downloadError"
                      @click="resumeDownload"
                      class="btn btn-success btn-sm">
                    <i class="bx bx-play me-1"></i>Resume
                  </button>
                  <button
                      @click="cancelDownload"
                      class="btn btn-danger btn-sm">
                    <i class="bx bx-x me-1"></i>Cancel
                  </button>
                </div>

                <div class="alert alert-info d-flex align-items-center" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
                </div>

                <!-- Download Statistics -->
                <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                  <div class="row text-center">
                    <div class="col-4">
                      <small class="text-muted d-block">Downloaded</small>
                      <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Remaining</small>
                      <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Success Rate</small>
                      <strong>{{ getSuccessRate() }}%</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Revert Dismiss Bill Modal -->
        <div class="modal fade" id="revertDismissModal" tabindex="-1" aria-labelledby="revertDismissModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-warning text-white">
                <h5 class="modal-title" id="revertDismissModalLabel">
                  <i class="mdi mdi-undo me-2"></i>Revert Dismissed Bill
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="mdi mdi-alert-circle-outline fs-4 me-2"></i>
                  <div>This action will restore a previously dismissed bill.</div>
                </div>

                <div class="mb-3">
                  <label for="revertBillNo" class="form-label fw-bold">Enter Bill Number:</label>
                  <input
                      type="text"
                      class="form-control"
                      id="revertBillNo"
                      v-model="revertBillNo"
                      placeholder="e.g., BLL0812113717047"
                      @keyup.enter="confirmRevertDismissBill"
                  >
                </div>

                <div v-if="revertError" class="alert alert-danger mt-3" role="alert">
                  <i class="mdi mdi-alert-circle me-2"></i>{{ revertError }}
                </div>

                <div v-if="revertSuccess" class="alert alert-success mt-3" role="alert">
                  <i class="mdi mdi-check-circle me-2"></i>{{ revertSuccess }}
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeRevertModal">
                  <i class="mdi mdi-close me-1"></i>Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-warning text-white"
                    @click="confirmRevertDismissBill"
                    :disabled="!revertBillNo || revertingBill"
                >
                  <span v-if="revertingBill">
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Reverting...
                  </span>
                  <span v-else>
                    <i class="mdi mdi-undo me-1"></i>Revert Bill
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Waiver Modal -->
        <div class="modal fade" id="waiverModal" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header" :class="waiverType === 'PWD WAIVER' ? 'bg-info' : 'bg-success'">
                <h5 class="modal-title text-white">
                  <i class="mdi mdi-file-document-edit me-2"></i>{{ waiverType }}
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <div v-if="waiverItem" class="mb-3 p-3 bg-light rounded">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-1"><small class="text-muted">Bill No:</small></p>
                      <p class="fw-bold mb-2">{{ waiverItem.billNo }}</p>
                    </div>
                    <div class="col-6">
                      <p class="mb-1"><small class="text-muted">Amount:</small></p>
                      <p class="fw-bold mb-2 text-primary">KES {{ numberFormat(waiverItem.billTotal) }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="mb-1"><small class="text-muted">Description:</small></p>
                      <p class="fw-semibold mb-0">{{ waiverItem.feeDescription }}</p>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label fw-bold">Waiver Amount <span class="text-danger">*</span></label>
                  <input
                      type="number"
                      v-model="waiverAmount"
                      class="form-control"
                      :max="waiverItem ? waiverItem.billTotal : 0"
                      min="1"
                      placeholder="Enter amount to waive"
                  >
                  <small class="text-muted">Maximum: KES {{ waiverItem ? numberFormat(waiverItem.billTotal) : 0 }}</small>
                </div>

                <div class="mb-3">
                  <label class="form-label fw-bold">Reason for Waiver <span class="text-danger">*</span></label>
                  <textarea
                      v-model="waiverReason"
                      class="form-control"
                      rows="4"
                      placeholder="Enter detailed reason for waiver request..."
                  ></textarea>
                </div>

                <div class="mb-3">
                  <label class="form-label fw-bold">Supporting Document <small class="text-muted">(Optional)</small></label>
                  <input
                      type="file"
                      class="form-control"
                      @change="handleWaiverFileUpload"
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  >
                  <small class="text-muted">Accepted formats: PDF, JPG, PNG, DOC, DOCX</small>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                  <i class="mdi mdi-close me-1"></i>Cancel
                </button>
                <button
                    type="button"
                    :class="waiverType === 'PWD WAIVER' ? 'btn-info' : 'btn-success'"
                    class="btn"
                    @click="submitWaiver"
                    :disabled="!waiverReason || !waiverAmount || waiverLoading"
                >
                  <span v-if="waiverLoading">
                    <span class="spinner-border spinner-border-sm me-1"></span>Submitting...
                  </span>
                  <span v-else>
                    <i class="mdi mdi-check me-1"></i>Submit Waiver Request
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Reuse Bill Detail Modal Component -->
        <BillDetailModal
            :billDetail="billDetail"
            :billInfo="billInfo"
            :billNo="billNo"
            @print-bill="printBill"
            @open-waiver="openWaiver"
            @description-updated="handleDescriptionUpdate"
            @customer-updated="handleCustopdate"
        />

        <!-- Alert for actions -->
        <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">© County Revenue System</div>
              <div class="col-sm-6">
                <div class="text-sm-end"
                     v-if="sessionStatusCode === '2'"
                     @click="openRevertModal"
                     type="button"
                     data-bs-toggle="modal"
                     data-bs-target="#revertDismissModal"
                     style="cursor: pointer;">
                  #Developed by County
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import BillDetailModal from "@/components/invoices/modals/BillDetailModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "BillsRaised",
  components: {
    NavigationBar,
    BillDetailModal
  },
  data() {
    return {
      download: 'Download',
      search: '',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      // Filters
      dateFrom: '',
      dateTo: '',
      selectedStream: '',

      // Data
      billDetails: [],
      billInfo: [],
      billDetail: {},
      billNo: '',

      // Location data
      subCounties: [],
      wards: [],
      zones: [],
      users: [],
      subCounty: '',
      ward: '',
      zone: '',
      selectedUser: '',

      // Revenue streams
      streams: [],

      // Summary
      summary: { count: 0, total: 0 },
      totalAmount: null,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Revert Dismiss Bill Modal
      revertBillNo: '',
      revertingBill: false,
      revertError: '',
      revertSuccess: '',

      // Session status code
      sessionStatusCode: '',

      // Waiver functionality
      waiverItem: null,
      waiverType: '',
      waiverReason: '',
      waiverAmount: '',
      waiverFile: null,
      waiverLoading: false,

      // ==================== DUPLICATE BILLS ====================
      selectedBills: [],
      dupTargetSubCounty: '',
      dupCopies: 10,
      dupDateFrom: '2025-06-01',
      dupDateTo: '2026-04-07',
      dupBillStatus: 'UNPAID',
      dupGenerating: false,
      dupResult: null,

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allRecordsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },
  computed: {
    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.receiptAmount || 0), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.billBalance || 0), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.detailAmount || 0), 0));
    },
    canDuplicate() {
      return this.selectedBills.length > 0
          && this.dupTargetSubCounty
          && this.dupCopies > 0
          && this.dupDateFrom
          && this.dupDateTo;
    }
  },
  watch: {
    pageSize() {
      this.getBillsPaginate();
      this.totalPages = Math.ceil(this.summary.count / this.pageSize);
      this.currentPage = 1;
    },
    search() {
      this.getBillsPaginate();
    },
    subCounty() {
      this.getWards();
      this.getBillsPaginate();
    },
    ward() {
      this.getBillsPaginate();
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    }
  },
  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    // Get session status code
    this.sessionStatusCode = sessionStorage.getItem("statusCode") || '';

    this.getAvailableStreams();
    this.getSubCounties();
    this.getBillsPaginate();
    this.menuAccess();
  },
  methods: {
    getRight,

    // Utility methods
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }
      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;
      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);
        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    gotTo(route) {
      router.push(route);
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;
      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    // ==================== DUPLICATE BILLS METHODS ====================

    toggleBillSelection(bill) {
      const index = this.selectedBills.findIndex(b => b.billNo === bill.billNo);
      if (index > -1) {
        this.selectedBills.splice(index, 1);
      } else {
        this.selectedBills.push(bill);
      }
    },

    isBillSelected(billNo) {
      return this.selectedBills.some(b => b.billNo === billNo);
    },

    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selectedBills = [...this.billDetails];
      } else {
        this.selectedBills = [];
      }
    },

    removeBillFromSelection(billNo) {
      this.selectedBills = this.selectedBills.filter(b => b.billNo !== billNo);
    },

    async submitDuplicateBills() {
      if (!this.canDuplicate) return;

      const isConfirmed = confirm(
          `You are about to create ${this.dupCopies} duplicate ${this.dupBillStatus} bills in ${this.dupTargetSubCounty.subCountyName}. Continue?`
      );
      if (!isConfirmed) return;

      this.dupGenerating = true;
      this.dupResult = null;

      try {
        const data = new FormData();
        data.append("function", "duplicateBills");
        data.append("billNumbers", JSON.stringify(this.selectedBills.map(b => b.billNo)));
        data.append("targetSubCountyID", this.dupTargetSubCounty.subCountyID);
        data.append("targetSubCountyName", this.dupTargetSubCounty.subCountyName);
        data.append("copies", this.dupCopies);
        data.append("dateFrom", this.dupDateFrom);
        data.append("dateTo", this.dupDateTo);
        data.append("billStatus", this.dupBillStatus);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, biller);
        this.dupGenerating = false;

        this.dupResult = res.data;

        if (res.data.success) {
          this.showAlert('success', res.data.message);
          this.selectedBills = [];
          this.getBillsPaginate();
        } else {
          this.showAlert('failed', res.data.message);
        }
      } catch (e) {
        this.dupGenerating = false;
        this.showAlert('failed', e.message);
      }
    },

    // ==================== WAIVER METHODS ====================

    openWaiver(item, type) {
      this.waiverItem = item;
      this.waiverType = type;
      this.waiverReason = '';
      this.waiverAmount = item.billTotal;
      this.waiverFile = null;

      const billModal = bootstrap.Modal.getInstance(document.getElementById('billDetailModal'));
      if (billModal) {
        billModal.hide();
      }

      setTimeout(() => {
        const waiverModal = new bootstrap.Modal(document.getElementById('waiverModal'));
        waiverModal.show();
      }, 300);
    },

    handleWaiverFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          this.showAlert('failed', 'File size must be less than 5MB');
          event.target.value = '';
          return;
        }
        this.waiverFile = file;
      }
    },

    async submitWaiver() {
      if (!this.waiverReason) {
        this.showAlert('failed', 'Please enter a reason for the waiver');
        return;
      }

      if (!this.waiverAmount || this.waiverAmount <= 0) {
        this.showAlert('failed', 'Please enter a valid waiver amount');
        return;
      }

      if (this.waiverAmount > this.waiverItem.billTotal) {
        this.showAlert('failed', 'Waiver amount cannot exceed the bill total');
        return;
      }

      this.waiverLoading = true;

      try {
        const data = new FormData();
        data.append("function", "initiateWaiver");
        data.append("id", this.waiverItem.id);
        data.append("billNo", this.waiverItem.billNo);
        data.append("waiverType", this.waiverType);
        data.append("reason", this.waiverReason);
        data.append("amount", this.waiverAmount);
        data.append("originalAmount", this.waiverItem.billTotal);
        data.append("feeDescription", this.waiverItem.feeDescription);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        if (this.waiverFile) {
          data.append("supportingDocument", this.waiverFile);
        }

        const res = await execute(data, biller);
        this.waiverLoading = false;

        if (res.data.success) {
          this.showAlert('success', 'Waiver request submitted successfully');

          const modal = bootstrap.Modal.getInstance(document.getElementById('waiverModal'));
          if (modal) {
            modal.hide();
          }

          this.resetWaiverForm();
          this.getBillsPaginate();
        } else {
          this.showAlert('failed', res.data.message || 'Failed to submit waiver request');
        }
      } catch (e) {
        this.waiverLoading = false;
        this.showAlert('failed', e.message || 'An error occurred while submitting the waiver');
      }
    },

    resetWaiverForm() {
      this.waiverItem = null;
      this.waiverType = '';
      this.waiverReason = '';
      this.waiverAmount = '';
      this.waiverFile = null;
    },

    // ==================== DOWNLOAD METHODS ====================

    downloadCurrentPage() {
      if (this.billDetails.length === 0) {
        this.showAlert('info', 'No data available to download');
        return;
      }

      try {
        const csv = this.generateCSV(this.billDetails);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Bills_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showAlert('success', `Successfully downloaded ${this.billDetails.length} records from current page`);
      } catch (error) {
        console.error('Download error:', error);
        this.showAlert('failed', 'Failed to download data: ' + error.message);
      }
    },

    generateCSV(data) {
      if (!data || data.length === 0) return '';

      const headers = [
        'NO.', 'Bill No', 'Description', 'Income Type', 'Fee Description',
        'Customer', 'Sub County', 'Ward', 'Zone', 'Attendant',
        'Billed Amount', 'Amount Paid', 'Balance', 'Status', 'Date Created'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.billNo),
          this.escapeCSV(item.description),
          this.escapeCSV(item.incomeTypeDescription),
          this.escapeCSV(item.feeDescription),
          this.escapeCSV(item.customers),
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          this.escapeCSV(item.zone),
          this.escapeCSV(item.names),
          item.detailAmount || 0,
          item.receiptAmount || 0,
          item.billBalance || 0,
          item.status || 'UNPAID',
          this.escapeCSV(item.dateCreated)
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    pauseDownload() {
      this.downloadPaused = true;
    },

    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      await this.continueDownload();
    },

    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');
      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];
      this.downloadProgress = {
        current: 0, total: 0, percentage: 0, records: 0, totalRecords: 0,
        startTime: null, estimatedTimeRemaining: null, averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1, currentPage: 0, batchSize: 1000, totalPages: 0, accumulatedData: []
      };
    },

    async downloadAllRecords() {
      if (!this.dateFrom || !this.dateTo) {
        this.showAlert('info', 'Please select date range before downloading');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} records from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1, currentPage: 0, batchSize: batchSize, totalPages: totalPages, accumulatedData: []
      };

      this.downloadProgress = {
        current: 0, total: totalPages, percentage: 0, records: 0, totalRecords: totalRecords,
        startTime: Date.now(), estimatedTimeRemaining: null, averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) return;
          if (this.downloadCancelled) return;

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchBillsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allRecordsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allRecordsData.length;
              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    async fetchBillsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("subCountyID", this.subCounty?.subCountyID || '');
        data.append("wardID", this.ward?.wardID || '');
        data.append("zone", this.zone);
        data.append("idNo", this.selectedUser);
        data.append("incomeTypePrefix", this.selectedStream);

        const res = await execute(data, biller);

        if (res.data.success) {
          return res.data.data.billDetails || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);
          return this.fetchBillsPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    async finalizeDownload() {
      if (this.allRecordsData.length > 0) {
        const csv = this.generateCSV(this.allRecordsData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = `All_Bills_${this.dateFrom}_to_${this.dateTo}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        this.showAlert('success', `Successfully downloaded ${this.allRecordsData.length} records!`);
        this.closeDownloadModal();
      } else {
        this.showAlert('info', 'No records found to download');
        this.closeDownloadModal();
      }
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // ==================== REVERT MODAL METHODS ====================

    openRevertModal() {
      this.revertBillNo = '';
      this.revertError = '';
      this.revertSuccess = '';
      this.revertingBill = false;
    },

    closeRevertModal() {
      this.revertBillNo = '';
      this.revertError = '';
      this.revertSuccess = '';
      this.revertingBill = false;
    },

    async confirmRevertDismissBill() {
      if (!this.revertBillNo) {
        this.revertError = 'Please enter a bill number';
        return;
      }

      this.revertError = '';
      this.revertSuccess = '';

      const isConfirmed = confirm(`Are you sure you want to revert dismissed bill ${this.revertBillNo}?`);
      if (!isConfirmed) return;

      this.revertingBill = true;

      try {
        const data = new FormData();
        data.append("function", "revertDismissBill");
        data.append("billNo", this.revertBillNo);

        const res = await execute(data, biller);
        this.revertingBill = false;

        if (res.data.success) {
          this.revertSuccess = `Bill ${this.revertBillNo} has been successfully reverted.`;
          this.showAlert('success', `Bill ${this.revertBillNo} has been successfully reverted.`);

          setTimeout(() => {
            this.revertBillNo = '';
            this.getBillsPaginate();

            const modalElement = document.getElementById('revertDismissModal');
            const modal = bootstrap.Modal.getInstance(modalElement);
            if (modal) {
              modal.hide();
            }
          }, 2000);
        } else {
          this.revertError = res.data.message || 'Failed to revert the bill. Please try again.';
          this.showAlert('failed', res.data.message);
        }
      } catch (e) {
        this.revertingBill = false;
        this.revertError = e.message || 'An error occurred while reverting the bill.';
        this.showAlert('failed', e.message);
      }
    },

    // ==================== API METHODS ====================

    async getAvailableStreams() {
      try {
        const data = new FormData();
        data.append("function", "getAvailableStreams");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.streams = res.data.data.streams;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    filterByStream(event) {
      this.selectedStream = event.target.value;
      this.getBillsPaginate();
    },

    async getBillsPaginate() {
      try {
        this.billDetails = [];
        this.loading = true;

        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("subCountyID", this.subCounty?.subCountyID || '');
        data.append("wardID", this.ward?.wardID || '');
        data.append("zone", this.zone);
        data.append("idNo", this.selectedUser);
        data.append("incomeTypePrefix", this.selectedStream);

        const res = await execute(data, biller);
        this.loading = false;

        if (res.data.success) {
          this.billDetails = res.data.data.billDetails;
          this.summary = res.data.data.summary;
          this.totalPages = Math.ceil(this.summary.count / this.pageSize);

          this.totalAmount = this.billDetails.reduce((acc, cur) => {
            return acc + Number(cur.receiptAmount || 0);
          }, 0);
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.loading = false;
        this.message = e.message;
      }
    },

    async dismissBill(billNo) {
      if (sessionStorage.getItem("statusCode") === "2") {
        const isConfirmed = confirm("Are you sure you want to dismiss this bill?");
        if (!isConfirmed) return;

        try {
          const data = new FormData();
          data.append("function", "dismissBill");
          data.append("billNo", billNo);

          const res = await execute(data, biller);
          if (res.data.success) {
            this.showAlert('success', res.data.message);
            this.getBillsPaginate();
          } else {
            this.showAlert('failed', res.data.message);
          }
        } catch (e) {
          this.showAlert('failed', e.message);
        }
      }
    },

    async invalidatePayment(billNo) {
      if (sessionStorage.getItem("statusCode") === "2") {
        const isConfirmed = confirm("Are you sure you want to invalidate this payment?");
        if (!isConfirmed) return;

        try {
          const data = new FormData();
          data.append("function", "invalidatePayment");
          data.append("billNo", billNo);

          const res = await execute(data, biller);
          if (res.data.success) {
            this.showAlert('success', res.data.message);
            this.getBillsPaginate();
          } else {
            this.showAlert('failed', res.data.message);
          }
        } catch (e) {
          this.showAlert('failed', e.message);
        }
      }
    },

    async getBill(billNo) {
      try {
        this.billNo = billNo;

        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo;
          this.billDetail = res.data.data.billDetails;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetail.billNo
      });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    handleDescriptionUpdate(data) {
      const index = this.billDetails.findIndex(item => item.billNo === data.billNo);
      if (index !== -1) {
        this.billDetails[index].description = data.description;
      }
      this.billDetail.description = data.description;
    },

    handleCustopdate(data) {
      const billIndex = this.billDetails.findIndex(item => item.billNo === this.billDetail.billNo);
      if (billIndex !== -1) {
        this.billDetails[billIndex].customers = data.customer;
      }

      const infoIndex = this.billInfo.findIndex(item => item.id === data.id);
      if (infoIndex !== -1) {
        this.billInfo[infoIndex].customer = data.customer;
      }
    },

    async getSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getWards() {
      try {
        this.wards = [];
        this.ward = '';

        if (!this.subCounty?.subCountyID) return;

        const data = new FormData();
        data.append("function", "getWards");
        data.append("subCountyID", this.subCounty.subCountyID);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.wards = res.data.data.wards;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getZones(wardID, wardName) {
      try {
        this.zones = [];

        if (wardName) {
          this.getBillsPaginate();
        }

        if (!wardID) return;

        const data = new FormData();
        data.append("function", "getZones");
        data.append("wardID", wardID);

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.zones = res.data.data.zones;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getUsers(zone) {
      try {
        this.users = [];

        if (zone) {
          this.getBillsPaginate();
        }

        const data = new FormData();
        data.append("function", "getUsers");
        data.append("search", zone || '');

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.users = res.data.data.users;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "All Raised Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate();
      }
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
  cursor: pointer;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.toast-container {
  z-index: 9999;
}

.text-decoration-none:hover {
  text-decoration: underline !important;
}

.modal-header.bg-warning {
  background-color: #ffc107 !important;
}

.btn-warning.text-white:hover {
  background-color: #ffca2c !important;
  border-color: #ffc720 !important;
}

.alert i {
  font-size: 1.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

#downloadProgressModal .modal-body {
  padding: 2rem;
}

#downloadProgressModal .progress {
  background-color: #e9ecef;
}

#downloadProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.text-muted strong {
  color: #495057;
  font-weight: 600;
}

#waiverModal .modal-header.bg-success {
  background-color: #198754 !important;
}

#waiverModal .modal-header.bg-info {
  background-color: #0dcaf0 !important;
}

#waiverModal .bg-light {
  background-color: #f8f9fa !important;
}

.table-primary {
  background-color: rgba(13, 110, 253, 0.08) !important;
}
</style>